import { LuPencil, LuEye, LuPlus } from 'react-icons/lu';
import {
  NAV_ITEMS,
  NAV_ITEM_ICONS,
  BREADCRUMB_LABELS,
} from '@/constant/layout/layout.constant';
import { ROUTE_CONFIG } from '@/config/Routes/routes.config';

/* ================= SIDEBAR MENU (UNCHANGED) ================= */
export const MenuItems = [
  // ── Overview ──────────────────────────────────────────────
  {
    label: NAV_ITEMS.DASHBOARD,
    link: `/${ROUTE_CONFIG.DASHBOARD.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.DASHBOARD],
  },

  // ── VDI Management ────────────────────────────────────────
  {
    label: NAV_ITEMS.VDI_TRANSACTIONS,
    link: `/${ROUTE_CONFIG.VDI_TRANSACTIONS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.VDI_TRANSACTIONS],
  },
  {
    label: NAV_ITEMS.PROVIDERS,
    link: `/${ROUTE_CONFIG.PROVIDERS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.PROVIDERS],
  },
  {
    label: NAV_ITEMS.OPERATORS,
    link: `/${ROUTE_CONFIG.OPERATORS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.OPERATORS],
  },

  // ── SmartCoolers ──────────────────────────────────────────
  {
    label: NAV_ITEMS.SMART_COOLERS,
    link: `/${ROUTE_CONFIG.SMART_COOLERS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SMART_COOLERS],
  },
  {
    label: NAV_ITEMS.SMART_COOLER_PRODUCTS,
    link: `/${ROUTE_CONFIG.SMART_COOLER_PRODUCTS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SMART_COOLER_PRODUCTS],
  },
  {
    label: NAV_ITEMS.COOLER_TRANSACTIONS,
    link: `/${ROUTE_CONFIG.SMART_COOLER_TRANSACTIONS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.COOLER_TRANSACTIONS],
  },
  // { label: NAV_ITEMS.APP_LOGS, link: "/applogs", icon: NAV_ITEM_ICONS[NAV_ITEMS.APP_LOGS] },
  {
    label: NAV_ITEMS.ALERTS,
    link: `/${ROUTE_CONFIG.SMART_COOLER_ALERTS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.ALERTS],
  },

  // ── Inventory ─────────────────────────────────────────────
  {
    label: NAV_ITEMS.MARKETS,
    link: `/${ROUTE_CONFIG.MARKETS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.MARKETS],
  },
  {
    label: NAV_ITEMS.PRODUCTS,
    link: `/${ROUTE_CONFIG.PRODUCTS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.PRODUCTS],
  },
  {
    label: NAV_ITEMS.DEVICES,
    link: `/${ROUTE_CONFIG.DEVICES.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.DEVICES],
  },
  {
    label: NAV_ITEMS.SALES,
    link: `/${ROUTE_CONFIG.SALES.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SALES],
  },

  // ── Admin Panel ───────────────────────────────────────────
  {
    label: NAV_ITEMS.CRONJOBS,
    link: `/${ROUTE_CONFIG.CRONJOBS.path}`,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.CRONJOBS],
  },
];

/* ================= FULL BREADCRUMB ROUTES ================= */
export const BreadCrumbRoute = [
  /* ===== DASHBOARD ===== */
  {
    path: `/${ROUTE_CONFIG.DASHBOARD.path}`,
    breadcrumb: BREADCRUMB_LABELS.DASHBOARD,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.DASHBOARD],
  },

  /* ===== VDI TRANSACTION ===== */
  {
    path: `/${ROUTE_CONFIG.VDI_TRANSACTIONS.path}`,
    breadcrumb: BREADCRUMB_LABELS.VDI_TRANSACTIONS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.VDI_TRANSACTIONS],
  },

  /* ===== SMART COOLER ===== */
  {
    path: `/${ROUTE_CONFIG.SMART_COOLER_PRODUCTS.path}`,
    breadcrumb: BREADCRUMB_LABELS.SMART_COOLER_PRODUCTS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SMART_COOLER_PRODUCTS],
  },

  {
    path: `/${ROUTE_CONFIG.SMART_COOLER_TRANSACTIONS.path}`,
    breadcrumb: BREADCRUMB_LABELS.COOLER_TRANSACTIONS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.COOLER_TRANSACTIONS],
  },

  /* ===== MARKET ===== */
  {
    path: `/${ROUTE_CONFIG.MARKETS.path}`,
    breadcrumb: BREADCRUMB_LABELS.MARKETS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.MARKETS],
  },

  /* ===== DEVICE ===== */
  {
    path: `/${ROUTE_CONFIG.DEVICES.path}`,
    breadcrumb: BREADCRUMB_LABELS.DEVICES,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.DEVICES],
  },

  /* ===== PRODUCTS ===== */
  {
    path: `/${ROUTE_CONFIG.PRODUCTS.path}`,
    breadcrumb: BREADCRUMB_LABELS.PRODUCTS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.PRODUCTS],
  },

  /* ===== SALES ===== */
  {
    path: `/${ROUTE_CONFIG.SALES.path}`,
    breadcrumb: BREADCRUMB_LABELS.SALES,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SALES],
  },

  /* ===== PROVIDER ===== */
  {
    path: `/${ROUTE_CONFIG.PROVIDERS.path}`,
    breadcrumb: BREADCRUMB_LABELS.PROVIDERS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.PROVIDERS],
  },
  {
    path: `/${ROUTE_CONFIG.PROVIDERS_CREATE.path}`,
    breadcrumb: BREADCRUMB_LABELS.CREATE_PROVIDER,
    icon: LuPlus,
  },
  {
    path: `/${ROUTE_CONFIG.PROVIDERS_EDIT.path}`,
    breadcrumb: BREADCRUMB_LABELS.EDIT_PROVIDER,
    icon: LuPencil,
  },
  {
    path: `/${ROUTE_CONFIG.PROVIDERS_VIEW.path}`,
    breadcrumb: BREADCRUMB_LABELS.VIEW_PROVIDER,
    icon: LuEye,
  },

  /* ===== OPERATORS ===== */
  {
    path: `/${ROUTE_CONFIG.OPERATORS.path}`,
    breadcrumb: BREADCRUMB_LABELS.OPERATORS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.OPERATORS],
  },
  {
    path: `/${ROUTE_CONFIG.OPERATORS.path}/:id`,
    breadcrumb: BREADCRUMB_LABELS.VIEW_OPERATOR,
    icon: LuEye,
  },

  /* ===== RECONCILIATION ===== */
  {
    path: `/${ROUTE_CONFIG.RECONCILIATION.path}`,
    breadcrumb: 'Reconciliation',
    icon: NAV_ITEM_ICONS[NAV_ITEMS.RECONCILIATION],
  },

  /* ===== TARGETED RECONCILIATION ===== */
  {
    path: `/${ROUTE_CONFIG.TARGETED_RECONCILIATION.path}`,
    breadcrumb: 'Targeted Reconciliation',
    icon: NAV_ITEM_ICONS[NAV_ITEMS.TARGETED_RECONCILIATION],
  },

  /* ===== QUICK PAY ===== */
  {
    path: `/${ROUTE_CONFIG.QUIKPICK.path}`,
    breadcrumb: 'Quick Pay',
    icon: NAV_ITEM_ICONS[NAV_ITEMS.QUICK_PAY],
  },

  /* ===== USERS ===== */
  {
    path: `/${ROUTE_CONFIG.USERS.path}`,
    breadcrumb: 'Users',
    icon: NAV_ITEM_ICONS[NAV_ITEMS.USERS],
  },
  { path: `/${ROUTE_CONFIG.USERS_VIEW.path}`, breadcrumb: 'View User', icon: LuEye },

  /* ===== CRON JOBS ===== */
  {
    path: `/${ROUTE_CONFIG.CRONJOBS.path}`,
    breadcrumb: BREADCRUMB_LABELS.CRON_JOBS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.CRONJOBS],
  },

  /* ===== ALERTS ===== */
  {
    path: `/${ROUTE_CONFIG.SMART_COOLER_ALERTS.path}`,
    breadcrumb: BREADCRUMB_LABELS.ALERTS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.ALERTS],
  },

  /* ===== APP LOGS ===== */
  {
    path: '/applogs',
    breadcrumb: BREADCRUMB_LABELS.APP_LOGS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.APP_LOGS],
  },

  /* ===== SMART COOLER ===== */
  {
    path: `/${ROUTE_CONFIG.SMART_COOLERS.path}`,
    breadcrumb: BREADCRUMB_LABELS.SMART_COOLERS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SMART_COOLERS],
  },
  {
    path: `/${ROUTE_CONFIG.SMART_COOLERS_VIEW.path}`,
    breadcrumb: BREADCRUMB_LABELS.SMART_COOLER_DETAILS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SMART_COOLERS],
  },

  /* ===== PROFILE ===== */
  {
    path: `/${ROUTE_CONFIG.PROFILE.path}`,
    breadcrumb: BREADCRUMB_LABELS.PROFILE,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.PROFILE],
  },

  /* ===== SETTINGS ===== */
  {
    path: '/settings',
    breadcrumb: BREADCRUMB_LABELS.SETTINGS,
    icon: NAV_ITEM_ICONS[NAV_ITEMS.SETTINGS],
  },
];